// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".additional-info-preloader-section[data-v-325dbd8e]{padding-bottom:2rem;padding-top:2rem}.border-bottom-dashed[data-v-325dbd8e]{background-image:linear-gradient(to right,var(--color-brand-24) 50%,transparent 0);background-position:bottom;background-repeat:repeat-x;background-size:1.25rem .0625rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
